module["exports"] = [
  "S.L.",
  "e Hijos",
  "S.A.",
  "Hermanos"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es_MX/company/suffix.js
// module id = 1144
// module chunks = 0